/* unplugin-vue-components disabled */import _regeneratorRuntime from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.parse-float.js";
import { useEmptyStringFormat } from '@/hooks/fn';
import { PieEchart } from '@/components/page-echarts';
import RankListItem from './cpns/RankListItem.vue';
import CTypeTab from '@/components/CTypeTab.vue';
import CDateHeaderWithBtn from './cpns/CDateHeaderWithBtn.vue';
import useCountInfo from './hooks';
export default defineComponent({
  name: 'SalesCount',
  components: {
    PieEchart: PieEchart,
    RankListItem: RankListItem,
    // BarEchartMul,
    CTypeTab: CTypeTab,
    CDateHeaderWithBtn: CDateHeaderWithBtn
  },
  setup: function setup() {
    var tabs = ref(['充值(元)', '消费(元)']);
    var curTab = ref('充值(元)');
    var params = ref({
      date: dayjs().format('YYYY/MM/DD'),
      type: 0 //时间类型 0日数据 1周数据 2月数据
    });
    var _useCountInfo = useCountInfo(params.value, curTab.value),
      countVal = _useCountInfo.countVal,
      getCountInfo = _useCountInfo.getCountInfo,
      customerCountInfo = _useCountInfo.customerCountInfo,
      getCustomerCountInfo = _useCountInfo.getCustomerCountInfo,
      logInfo = _useCountInfo.logInfo,
      getLogInfo = _useCountInfo.getLogInfo,
      rechargeTypeInfo = _useCountInfo.rechargeTypeInfo,
      getRechargeTypeInfo = _useCountInfo.getRechargeTypeInfo,
      resetPage = _useCountInfo.resetPage,
      listFinished = _useCountInfo.listFinished,
      listLoading = _useCountInfo.listLoading,
      rechargeCountInfo = _useCountInfo.rechargeCountInfo,
      getRechargeCountInfo = _useCountInfo.getRechargeCountInfo,
      consumptionCountInfo = _useCountInfo.consumptionCountInfo,
      getConsumptionCountInfo = _useCountInfo.getConsumptionCountInfo;
    var getInfo = function getInfo() {
      getCountInfo();
      getCustomerCountInfo();
      getLogInfo();
      getRechargeTypeInfo();
      getRcCountInfo();
    };
    var getRcCountInfo = function getRcCountInfo() {
      if (countCurTab.value === '充值(元)') {
        getRechargeCountInfo();
      } else {
        getConsumptionCountInfo();
      }
    };
    var confrimDate = function confrimDate(val) {
      params.value.date = val;
      resetPage();
      getInfo();
    };
    var dateRef = ref();
    var confirmType = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(val) {
        var _dateRef$value;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              params.value.type = val;
              //把所以日期控件的日期变为当前最新日期
              (_dateRef$value = dateRef.value) === null || _dateRef$value === void 0 || _dateRef$value.reset();
              params.value.date = dayjs().format('YYYY/MM/DD');
              resetPage();
              getInfo();
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function confirmType(_x) {
        return _ref.apply(this, arguments);
      };
    }();
    var emptyStringFormat = useEmptyStringFormat();
    var tabClick = function tabClick(val) {
      curTab.value = val;
      resetPage();
      getLogInfo();
    };
    var countTabs = ref(['充值(元)', '消费(元)']);
    var countCurTab = ref('充值(元)');
    var countTabClick = function countTabClick(val) {
      countCurTab.value = val;
      getRcCountInfo();
    };
    var countInfoPie = computed(function () {
      var list = [];
      var unit = '';
      if (countCurTab.value === '充值(元)') {
        var _rechargeCountInfo$va, _rechargeCountInfo$va2;
        list = [{
          name: '线下',
          value: parseFloat((_rechargeCountInfo$va = rechargeCountInfo.value.upDownMoney) !== null && _rechargeCountInfo$va !== void 0 ? _rechargeCountInfo$va : '0')
        }, {
          name: '易购',
          value: parseFloat((_rechargeCountInfo$va2 = rechargeCountInfo.value.upOnMoney) !== null && _rechargeCountInfo$va2 !== void 0 ? _rechargeCountInfo$va2 : '0')
        }];
      }
      if (countCurTab.value === '消费(元)') {
        var _consumptionCountInfo, _consumptionCountInfo2;
        list = [{
          name: '线下',
          value: parseFloat((_consumptionCountInfo = consumptionCountInfo.value.saleDownMoney) !== null && _consumptionCountInfo !== void 0 ? _consumptionCountInfo : '0')
        }, {
          name: '易购',
          value: parseFloat((_consumptionCountInfo2 = consumptionCountInfo.value.saleUpMoney) !== null && _consumptionCountInfo2 !== void 0 ? _consumptionCountInfo2 : '0')
        }];
      }
      return {
        pieData: list,
        unit: unit,
        customTooltip: true,
        tooltipFormatter: function tooltipFormatter(params) {
          var res = "\n              <div >\n              ";
          if (countCurTab.value === '充值(元)') {
            res += "\n                  <div class=\"flex align-start\">\n                    <span class=\"mt-1 mr-1\">".concat(params.marker, "</span>\n                    <div>\n                      <span style=\"font-size: 16px;\">").concat(params.name, "</span>\n                      <div>\n                        <span style=\"font-size: 16px;\">").concat(params.value, "\u5143</span>\n                      </div>\n                    </div>\n                  </div>\n                ");
          }
          if (countCurTab.value === '消费(元)') {
            res += "\n                  <div class=\"flex align-start\">\n                    <span class=\"mt-1 mr-1\">".concat(params.marker, "</span>\n                    <div>\n                      <span style=\"font-size: 16px;\">").concat(params.name, "</span>\n                      <div>\n                       <span style=\"font-size: 16px;\">").concat(params.value, "\u5143</span>\n                      </div>\n                    </div>\n                  </div>\n                ");
          }
          res += '</div>';
          return res;
        }
      };
    });
    var countData = computed(function () {
      return [{
        num: customerCountInfo.value.userCount,
        desc: '新增客户'
      }, {
        num: countVal.value.orderCount,
        desc: '订单数'
      }, {
        num: countVal.value.carCount,
        desc: '车次'
      }];
    });
    onMounted(function () {
      getInfo();
    });
    // const router = useRouter();
    var typeTabs = ['日', '月', '年', '全部'];
    return {
      params: params,
      confirmType: confirmType,
      confrimDate: confrimDate,
      emptyStringFormat: emptyStringFormat,
      // aggregateSaleData,
      // summaryData,
      countData: countData,
      tabs: tabs,
      curTab: curTab,
      tabClick: tabClick,
      countTabs: countTabs,
      countCurTab: countCurTab,
      countTabClick: countTabClick,
      dateRef: dateRef,
      typeTabs: typeTabs,
      logInfo: logInfo,
      rechargeTypeInfo: rechargeTypeInfo,
      listFinished: listFinished,
      listLoading: listLoading,
      getLogInfo: getLogInfo,
      rechargeCountInfo: rechargeCountInfo,
      consumptionCountInfo: consumptionCountInfo,
      countInfoPie: countInfoPie
    };
  }
});